import { push, ref } from "firebase/database";
import { useState } from "react";
import { database } from "../firebase"; // Adjust path based on your project

const EmployeeRegistration = () => {
  const [formData, setFormData] = useState({
    name: "",
    gender: "",
    email: "",
    mobile: "",
    qualification: "",
    state: "",
    city: "",
    pincode: "",
    parentName: "",
    idType: "",
    idNumber: "",
    course: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const studentRef = ref(database, "Employees");
  const now = new Date();
const isoDate = now.toISOString(); // "2025-05-30T13:45:00.000Z"

const dataToPush = {
  ...formData,     // all your form fields here
 date: isoDate,   // plus the date added dynamically
};
push(studentRef, dataToPush)   // push the combined object

      .then(() => {
        alert("Registration successful!");
        setFormData({
          name: "",
          gender: "",
          email: "",
          mobile: "",
          qualification: "",
          state: "",
          city: "",
          pincode: "",
          parentName: "",
          idType: "",
          idNumber: "",
          course: "",
        });
      })
      .catch((error) => {
        alert("Error: " + error.message);
      });
  };

  return (
    <div className="navbar_parent">
      <nav className="navbar navbar-default navbar-fixed-top" id="myScrollspy">
        <div className="container">
          <div className="navbar-header menu-header-mobile">
            <div className="navbar-brand">
              <img
                src="https://teplassets.s3.ap-south-1.amazonaws.com/logo/logo.png?v=2"
                style={{ width: "115px" }}
                className="mt-4"
                alt="tallyeducation logo"
              />
            </div>
          </div>
          <div className="text-right hidden-mobile-menu">
            <img
              src={`${process.env.PUBLIC_URL}/tl.png`}
              className="mt-4"
              alt="tallysolutions logo"
              style={{ width: "135px" }}
            />
          </div>
        </div>
      </nav>

      <div
        className="container w-100 align-content-center"
        style={{ border: "solid 1.5px rgb(177, 223, 70)" }}
      ></div>

      <div className="container margin-top-cont">
        <form onSubmit={handleSubmit}>
          <div className="form-group row" style={{ textAlign: "left", marginTop: "20px" }}>
            <div className="col-lg-12 col-md-12 col-sm-12 text-muted">
              <div className="fs-5">
                <span>Interested in Working with Us <b></b>?</span>
              </div>
              <div className="fs-5 mt-3">
                <span>Please fill the form below and we will get back to you!</span>
                <input type="hidden" id="tcoeID" name="tcoeID" value="14985" />
              </div>
            </div>
          </div>

          <div className="form-group row fs-5" style={{ textAlign: "center", marginTop: "50px" }}>
            <div
              className="col-lg-6 col-md-6 col-sm-12 bord-right mb-4"
              style={{ borderRight: "3px solid rgb(204, 233, 137)", padding: "20px" }}
            >
              <div className="form-control border-0 text-muted">
                <span>Personal Information</span>
                <input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Name *"
                  type="text"
                  required
                  className="form-control"
                />
              </div>
              <div className="form-control border-0">
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  required
                  className="select form-control text-muted"
                >
                  <option value="">Gender *</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
              <div className="form-control border-0">
                <input
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="E-mail *"
                  type="email"
                  className="form-control"
                  required
                />
              </div>
              <div className="form-control border-0">
                <input
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder="Mobile *"
                  type="text"
                  className="form-control"
                  required
                />
              </div>
              <div className="form-control border-0">
                <select
                  name="qualification"
                  value={formData.qualification}
                  onChange={handleChange}
                  className="select form-control text-muted"
                >
                  <option value="">Qualification *</option>
                  <option value="Any Graduate">Any Graduate</option>
                  <option value="X Standard">X Standard</option>
                  <option value="ITI/Diploma">ITI/Diploma</option>
                  <option value="XII Standard">XII Standard</option>
                  <option value="B.Com">B.Com</option>
                  <option value="B.E/B.Tech">B.E/B.Tech</option>
                  <option value="BBA/BBM">BBA/BBM</option>
                  <option value="Other">Other</option>
                  <option value="M.Com">M.Com</option>
                  <option value="MBA">MBA</option>
                  <option value="Professional qualification">Professional qualification</option>
                </select>
              </div>
              <div className="form-control border-0 text-muted">
                <span>Address Information</span>
                <select
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  required
                  className="select form-control text-muted"
                >
                  <option value="">Select State *</option>
                  <option value="Madhya Pradesh">Madhya Pradesh</option>
                </select>
              </div>
              <div className="form-control border-0">
                <select
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                  className="select form-control text-muted"
                >
                  <option value="">Select City *</option>
<option value="Agar Malwa">Agar Malwa</option>
<option value="Alirajpur">Alirajpur</option>
<option value="Anuppur">Anuppur</option>
<option value="Ashok Nagar">Ashok Nagar</option>
<option value="Balaghat">Balaghat</option>
<option value="Barwani">Barwani</option>
<option value="Betul">Betul</option>
<option value="Bhind">Bhind</option>
<option value="Bhopal">Bhopal</option>
<option value="Burhanpur">Burhanpur</option>
<option value="Chhatarpur">Chhatarpur</option>
<option value="Chhindwara">Chhindwara</option>
<option value="Damoh">Damoh</option>
<option value="Datia">Datia</option>
<option value="Dewas">Dewas</option>
<option value="Dhar">Dhar</option>
<option value="Dindori">Dindori</option>
<option value="Guna">Guna</option>
<option value="Gwalior">Gwalior</option>
<option value="Harda">Harda</option>
<option value="Hoshangabad">Hoshangabad</option>
<option value="Indore">Indore</option>
<option value="Jabalpur">Jabalpur</option>
<option value="Jhabua">Jhabua</option>
<option value="Katni">Katni</option>
<option value="Khandwa">Khandwa</option>
<option value="Khargone">Khargone</option>
<option value="Mandla">Mandla</option>
<option value="Mandsaur">Mandsaur</option>
<option value="Morena">Morena</option>
<option value="Narsinghpur">Narsinghpur</option>
<option value="Neemuch">Neemuch</option>
<option value="Panna">Panna</option>
<option value="Raisen">Raisen</option>
<option value="Rajgarh">Rajgarh</option>
<option value="Ratlam">Ratlam</option>
<option value="Rewa">Rewa</option>
<option value="Sagar">Sagar</option>
<option value="Satna">Satna</option>
<option value="Sehore">Sehore</option>
<option value="Seoni">Seoni</option>
<option value="Shahdol">Shahdol</option>
<option value="Shajapur">Shajapur</option>
<option value="Sheopur">Sheopur</option>
<option value="Shivpuri">Shivpuri</option>
<option value="Sidhi">Sidhi</option>
<option value="Singrauli">Singrauli</option>
<option value="Tikamgarh">Tikamgarh</option>
<option value="Ujjain">Ujjain</option>
<option value="Umaria">Umaria</option>
<option value="Vidisha">Vidisha</option>

                </select>
              </div>
              <div className="form-control border-0">
                <input
                  name="pincode"
                  value={formData.pincode}
                  onChange={handleChange}
                  placeholder="Pincode *"
                  type="text"
                  className="form-control"
                  required
                />
              </div>
              <div className="form-control border-0">
                <input
                  name="parentName"
                  value={formData.parentName}
                  onChange={handleChange}
                  placeholder="Parent's Name"
                  type="text"
                  className="form-control"
                />
              </div>
              <div className="form-control border-0">
                <select
                  name="idType"
                  value={formData.idType}
                  onChange={handleChange}
                  className="select form-control text-muted"
                >
                  <option value="">ID Proof Type</option>
                  <option value="Aadhar">Aadhar</option>
                  <option value="PAN">PAN</option>
                  <option value="Voter ID">Voter ID</option>
                </select>
              </div>
              <div className="form-control border-0">
                <input
                  name="idNumber"
                  value={formData.idNumber}
                  onChange={handleChange}
                  placeholder="ID Proof Number"
                  type="text"
                  className="form-control"
                />
              </div>
              <div className="form-control border-0 text-muted">
                <span>Interested in Certification</span>
                <select
                  name="course"
                  value={formData.course}
                  onChange={handleChange}
                  className="select form-control mt-2 text-muted"
                >
                  <option value="">Course/Certification</option>
                  <option value="Tally Professional">Tally Professional</option>
                  <option value="Tally Expert">Tally Expert</option>
                  <option value="GST Course">GST Course</option>
                </select>
              </div>
              <div className="row" style={{ marginTop: "20px" }}>
                <div className="form-control border-0">
                  <div id="recaptcha1" className="col-lg-12 col-md-12 col-sm-12 g-recaptcha"></div>
                  <h6
                    style={{ fontSize: "20px", margin: "10px", color: "black" }}
                    id="captchaError1"
                  ></h6>
                </div>
              </div>
              <div
                className="row"
                style={{ textAlign: "center", paddingBottom: "35px", paddingTop: "10px" }}
              >
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <button
                    id="submitForm"
                    name="Submit"
                    type="submit"
                    className="btn border-0 text-light p-2 fs-5 w-50"
                    style={{ background: "#90b732" }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 text-start text-muted fs-6">
              <div className="ContactDetails">
                <span>Contact Details:<br /></span>
                <div>
                  <span>Puran Thana Asati ward no-1 Nearby SBI ATM,<br />Damoh,<br />Madhya Pradesh - 470661</span>
                </div>
                <div>
                  <span>Phone: 9131385180</span>
                </div>
                <div>
                  <span>E-mail: shrikanttallyinstitute@gmail.com</span>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

  );
};

export default EmployeeRegistration;
